import axios, { buildApi } from '@/libs/api.request';
let name = '/report/returns'

export const apis = buildApi({
  get: [name + '/index&list',],
})